import {ExpressCheckoutController} from '@wc-stripe/controllers';
import {getSetting} from '@wc-stripe/utils';
import Context from '@wc-stripe/context';
import {GooglePayGateway} from '@wc-stripe/gateways'

const settings = getSetting('stripe_googlepay_data');

const context = new Context('express_checkout');

const gateway = new GooglePayGateway({
    id: 'stripe_googlepay',
    settings,
    context
});

const controller = new ExpressCheckoutController({
    context,
    gateway,
    selector: '.banner_payment_method_stripe_googlepay'
});

controller.initialize();